import {
  ButtonBase,
  Container,
  delayedCall,
  dispatcher,
  ingenuity,
  killDelayedCall,
  SpineBase,
} from "@quest/base-core";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { CollectionModel } from "./CollectionModel";
import { Emitter } from "@quest/pixi-bridge";
import { ButtonBaseBehavior, MeterBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { EventConstants } from "@quest/platform-murka-phase_2";
import { CollectionBannerView } from "./CollectionBannerView";
import { gameConstants } from "../Constants/gameConstants";

export class CollectionBannerController {
  protected view: CollectionBannerView;
  protected model: CollectionModel;
  protected bannerMainContainer: Container;
  protected currentWinAmounts: any = {};
  protected winCount: number;
  protected isPlayingWin: boolean;
  private frontEmitter: Emitter;
  private backEmitter: Emitter;
  private continueButton: ButtonBaseBehavior;
  private bannerContinueButtonContainer: Container;
  private bannerBg: SpineBase;
  private bannerPortBg: SpineBase;
  private bannerSpine: SpineBase;
  private bannerPortSpine: SpineBase;
  private totalBannerWin : number = 0;

  constructor(view: any, model: CollectionModel) {
    this.view = view;
    this.model = model;
    this.init();
  }

  protected init(): void {
    this.subscribeEvents();
    this.initializeElements();
  }
  protected subscribeEvents(): void {
    dispatcher.on(eventDispatchers.SHOW_COLLECTION_WINS, this.onShowCollectionWins, this);
    dispatcher.on(eventDispatchers.SHOW_BANNER_WIN, this.onShowBannerWinAnims, this);
    dispatcher.on(eventDispatchers.ADD_COLLECTION_BANNER_ON_TOP, this.view.addViewToTop, this.view);
  }

  protected initializeElements(): void {
    this.bannerMainContainer = this.view.getContainerByID("collectionBannerContainer");
    this.continueButton = this.view.getButtonById("continueButton") as ButtonBaseBehavior;
    this.bannerContinueButtonContainer = this.view.getContainerByID("bannerContinueButtonContainer");
    this.continueButton.on(ButtonBase.UP, this.onContinuePressUp, this);
    this.bannerBg = this.view.getSpineById("bannerBGSpine");
    this.bannerPortBg = this.view.getSpineById("bannerPortBGSpine");
    this.bannerSpine = this.view.getSpineById("bannerSpine");
    this.bannerPortSpine = this.view.getSpineById("bannerPortSpine");
  }

  protected onShowBannerWinAnims(): void {
    this.bannerMainContainer.visible = true;
    this.continueButton.disableAndTint();
    !ingenuity.deviceEnv.isDesktop && this.onShowBannerWinAnimsPort();
    const winCollection = this.model.getCurrentWin() === "exp" ? "experienced" : this.model.getCurrentWin();
    this.bannerBg.visible = true;
    this.bannerSpine.visible = true;
    this.bannerBg.setPause(false);
    this.bannerSpine.setPause(false);
    this.bannerBg.playAnim(`desktop_${winCollection}_BG`, true);
    (ingenuity.soundManager as any).playSound(
      "cashback_popup_win",
      1,
      false,
      SlotConstantsBehavior.SOUND_LIST_POSTLOAD
    );
    this.bannerSpine.playAnim(`desktop_${winCollection}_intro`, false);
    this.bannerSpine.onComplete.addOnce(() => {
      this.bannerSpine.playAnim(`desktop_${winCollection}_loop`, true);
    }, this)
    delayedCall(
      "afterIntroPresentationDelay",
      600,
      () => {
        killDelayedCall("afterIntroPresentationDelay");
        this.startExplodeCoinAnim();
        this.playRearCoinShower();
        this.totalBannerWin = this.totalBannerWin +this.model.getCollectionUpdatedWinAmount((ingenuity.parserModel as GameParserModel).getTriggeredBait(),gameConstants.COLLECTION_LEVELS_SERVER_ID[gameConstants.COLLECTION_LEVELS_GAME.indexOf(this.model.getCurrentWin())])
        this.startJackpotOutroTickup(
          this.model.getCollectionUpdatedWinAmount(
            (ingenuity.parserModel as GameParserModel).getTriggeredBait(),
            gameConstants.COLLECTION_LEVELS_SERVER_ID[gameConstants.COLLECTION_LEVELS_GAME.indexOf(this.model.getCurrentWin())]
          )
        );
      },
      this
    );
  }
  protected onShowBannerWinAnimsPort(): void {
    const winCollection = this.model.getCurrentWin() === "exp" ? "experienced" : this.model.getCurrentWin();
    this.bannerPortBg.visible = true;
    this.bannerPortSpine.visible = true;
    this.bannerPortBg.setPause(false);
    this.bannerPortSpine.setPause(false);
    this.bannerPortBg.playAnim(`portrait_${winCollection}_BG`, true);
    this.bannerPortSpine.playAnim(`portrait_${winCollection}_intro`, true);
    this.bannerPortSpine.onComplete.addOnce(() => {
      this.bannerPortSpine.playAnim(`portrait_${winCollection}_loop`, true);
    }, this)


  }

  protected startJackpotOutroTickup(amount: number): void {
    const bannerWinMeter = this.view.getMeterById("OutroWinAmount") as MeterBehavior;
    bannerWinMeter.setValue(0);
    bannerWinMeter.visible = true;
    this.view.getContainerByID("taptoclickMessage").alpha = 0.7;
    this.view.getContainerByID("taptoclickMessage").visible = true;
    this.continueButton.disableAndTint();
    bannerWinMeter.startTick(amount, true, false, 1.5, true, () => {
      this.bannerContinueButtonContainer.visible = true;
      this.continueButton.enableAndTint();
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
    });
  }
  protected onShowCollectionWins(): void {
    this.view.addViewToTop();
    const pendingWins = this.model.getPendingWins();
    if (pendingWins.length === 0) {
    this.totalBannerWin = 0;
      dispatcher.fireEvent(EventConstants.UPDATE_BS_WIN, {
        value:
          (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() +
          (ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin() +
          (ingenuity.parserModel as GameParserModel).getCollectionCreditsWon(),
      });
      delayedCall(
        "collectionScreenHideDelay",
        3000,
        () => {
          killDelayedCall("collectionScreenHideDelay");
          dispatcher.fireEvent(eventDispatchers.HIDE_COLLECTION_SCREEN);
        },
        this
      );
      return;
    }
    this.isPlayingWin = true;
    this.model.setCurrentWin(pendingWins.shift());
    this.model.setPendingWins(pendingWins);

    dispatcher.fireEvent(eventDispatchers.SHOW_BUBBLE_GLOW);
  }

  private startExplodeCoinAnim(): void {
    this.initializeCoinExplodeEmitter();
    this.startCoinExplodeEmitter();
  }

  private initializeCoinExplodeEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinfrontEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 30,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 1,
        end: 1.47,
        minimumScaleMultiplier: 1,
      },
      speed: {
        start: 300,
        end: 500,
        minimumSpeedMultiplier: 4,
      },
      acceleration: {
        x: 0,
        y: 750,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: 360,
      },
      noRotation: false,
      rotationSpeed: {
        min: 0,
        max: 10,
      },
      lifetime: {
        min: 5,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.001,
      emitterLifetime: 1,
      maxParticles: 100,
      pos: {
        x: 0,
        y: 50,
      },
      addAtBack: true,
      spawnType: "burst",
      particlesPerWave: 10,
      particleSpacing: 0,
      angleStart: 0,
    };
    const coinShowerContainer1: Container = this.view.getContainerByID("bannerFrontCoinBlastContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer1, particleData, config) as Emitter;
  }

  private startCoinExplodeEmitter(): void {
    this.frontEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinfrontEmitter");
    this.frontEmitter.autoUpdate = true;
    this.frontEmitter.emit = true;
  }

  private playRearCoinShower(): void {
    this.initializeCoinShowerEmitter();
    this.startCoinShowerEmitter();
  }

  private initializeCoinShowerEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.8,
        end: 1.2,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 200,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: 360,
      },
      noRotation: false,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.01,
      emitterLifetime: -1,
      maxParticles: 1500,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("bannerRearCoinBlastContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as Emitter;
  }
  private startCoinShowerEmitter(): void {
    this.backEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter");
    this.backEmitter.autoUpdate = true;
    this.backEmitter.emit = true;
  }
  private onContinuePressUp(): void {
    this.continueButton.disableAndTint();
    if (this.backEmitter) {
      this.backEmitter.destroy();
      this.backEmitter.emit = false;
    }
    dispatcher.fireEvent(EventConstants.UPDATE_BS_WIN, {
      value:
        (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() +
        (ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin() +
        this.totalBannerWin
    });
    this.playOutroBannerAnims();
    !ingenuity.deviceEnv.isDesktop && this.playOutroPortAnims();
  }

  protected playOutroBannerAnims(): void {
    const winCollection = this.model.getCurrentWin() === "exp" ? "experienced" : this.model.getCurrentWin();
    this.bannerSpine.playAnim(`desktop_${winCollection}_outro`, false);
    this.bannerBg.visible = false;
    this.bannerContinueButtonContainer.visible = false;
    this.view.getContainerByID("taptoclickMessage").visible = false;
    this.view.getMeterById(`OutroWinAmount`).visible = false;
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_AFTER_WIN, this.model.getCurrentWin());
    this.bannerSpine.onComplete.addOnce(() => {
      this.bannerSpine.visible = false;
      this.resetBanner();
      this.onShowCollectionWins();
    });
  }
  protected playOutroPortAnims(): void {
    const winCollection = this.model.getCurrentWin() === "exp" ? "experienced" : this.model.getCurrentWin();
    this.bannerPortSpine.playAnim(`portrait_${winCollection}_outro`, false);
    this.bannerPortBg.visible = false;

  }

  protected resetBanner(): void {
    this.view.getMeterById(`OutroWinAmount`).setValue(0);
    this.bannerMainContainer.visible = false;
    this.frontEmitter.destroy();
    this.frontEmitter.emit = false;
    this.bannerBg.setPause(true);
    this.bannerSpine.setPause(true);
    this.bannerPortBg.setPause(true);
    this.bannerPortSpine.setPause(true);
    this.view.getContainerByID("bannerRearCoinBlastContainer").removeChildren();
    this.view.getContainerByID("bannerFrontCoinBlastContainer").removeChildren();
  }
}
